import { Fragment, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { DatePicker, TimeField } from '@mui/x-date-pickers';
import { Breadcrumbs, Typography, Box, FormControl, Select, MenuItem, Paper, FormControlLabel, RadioGroup, Radio, IconButton, InputBase, Divider, InputLabel, TableContainer, TableBody, TableRow, TableCell, Table, OutlinedInput, TextField } from '@mui/material';
import dayjs from '../../../../config/dayjs';
import { listByDriveAndCourse } from '../../../../services/masterService';
import { getDetailsWithQuestionsStatusById } from '../../../../services/configurationService';
import { MainContainer, Container } from '../../../../components';
import { Menu } from '../Menu/Menu';
import languages from '../../../../constant/languages';

import ARROW from '../../../../assets/images/breadcrumb-arrow.svg';
import ARROW_OPEN from '../../../../assets/images/breadcrumb-arrow-open.svg';
import RadiusButton from '../../../../components/RadiusButton';
import TRUE_BLACK from '../../../../assets/images/true-black.svg';
import ARROW_LEFT from '../../../../assets/images/back.svg';

import './ViewContentConfiguration.scss';
import { ProjectContext } from '../../../../providers/projectProvider';


export const ViewContentConfiguration = () => {
    const params = useParams();
    const projectName = params?.projectName;
    const { projectDetails } = useContext(ProjectContext);

    const [drive, setDrive] = useState({
        id: null,
        name: 'Drive name'
    });
    const [course, setCourse] = useState({
        id: null,
        name: 'Course name'
    });

    const [configurationId, setConfigurationId] = useState(null);
    const [configuration, setConfiguration] = useState({
        examType: 'MCQ',
        timeDuration: dayjs.utc().hour(0).minute(0).second(0).millisecond(0),
        timeDurationForScribe: dayjs.utc().hour(0).minute(0).second(0).millisecond(0),
        startExamBetweenSpecifiedTime: false,
        examTimes: [],
        unlockWithPassword: 'No',
        autoLogout: 'No',
        submitButtonDisplayMinutes: dayjs.utc().hour(0).minute(0).second(0).millisecond(0),
        calculator: 'No',
        provideGraph: 'No',
        logarithm: 'No',
        calculatorType: 'normal',
        feedback: 'No',
        numberOfFeedbackQuestions: 1,
        sectionWise: 'No',
        sectionNavigation: 'NO_MOVEMENT_OR_TIME_RESTRICTION',
        sectionCount: 1,
        sections: [{
            sectionTitle: 'Section 1',
            sectionTime: dayjs.utc().hour(0).minute(0).second(0).millisecond(0),
            subSectionsCount: 0,
            subSections: []
        }],
        contentUploadMethod: 'set',
        numberOfEasyQuestions: 0,
        numberOfMediumQuestions: 0,
        numberOfHardQuestions: 0,
        numberOfSets: 1,
        questionsPerSet: 1,
        maxMarks: 1,
        randomizeQuestions: 'No',
        randomizeOptions: 'No',
        isBilingual: 'No',
        languages: [],
        instructionSheets: 'No',
        biometricRequired: 'Yes',
        biometricMethod: 'photo',
        sampleTestRequired: 'No',
        allQuestionsMandatory: 'No',
        questionNavigationForwardOnly: 'No',
        negativeMarking: 'No',
        numberOfAnswerPages: 1,
        maximumLoginAttempts: 'No',
        maximumLoginAttemptsCount: 1,
        lateLoginAllowed: 'No',
        lateLoginMinutes: dayjs.utc().hour(0).minute(0).second(0).millisecond(0),
        noMovementTimeRestriction: 'No',
        fixedTimeMovementRestriction: 'No',
        movementRestrictionIncrementalTime: 'No',
        movementRestrictionNoTime: 'No',
        loginBeforeMinutes: dayjs.utc().hour(0).minute(30).second(0).millisecond(0),
        reminders: [],
        instantScore: 'No',
        instantResult: 'No'
    });

    const location = useLocation();
    const navigate = useNavigate();
    const onGoBack = () => {
        navigate(`/${projectName}/upload`, {
            state: {
                drive: drive,
                course: course,
                configurationId: configurationId,
                activeTab: 'content',
            }
        });
    }

    useEffect(() => {
        const driveDetails = location?.state?.drive;
        const courseDetails = location?.state?.course;
        const configurationId = location?.state?.configurationId;
        console.log(driveDetails, courseDetails, configurationId);
        if (!driveDetails || !courseDetails) {
            onGoBack();
        } else {
            setDrive(() => driveDetails);
            setCourse(() => courseDetails);
            setConfigurationId(configurationId);
            const getBatches = async () => {
                try {
                    const res = await listByDriveAndCourse(driveDetails.id, courseDetails.id);
                    if (res.code === 'OK') {
                        const batches = res.data.list.map((pm) => {
                            return {
                                projectMasterId: pm.id,
                                batchId: pm.batchId,
                                batchName: pm['batch.batchName'],
                                examDate: dayjs.utc(pm.examDate),
                                startTime: dayjs.utc(pm.examDate).hour(0).minute(0).second(0).millisecond(0),
                                endDate: dayjs.utc(pm.examDate),
                                endTime: dayjs.utc(pm.examDate).hour(0).minute(0).second(0).millisecond(0),
                            }
                        })
                        if (configurationId) {
                            const fetchDetails = async () => {
                                try {
                                    const res = await getDetailsWithQuestionsStatusById(configurationId);
                                    if (res.code === 'OK') {
                                        const data = res.data;
                                        const dataToSet = {
                                            examType: data.examType,
                                            timeDuration: dayjs.utc().hour(data.timeDuration.split(':')[0]).minute(data.timeDuration.split(':')[1]).second(0).millisecond(0),
                                            timeDurationForScribe: dayjs.utc().hour(data.timeDurationForScribe.split(':')[0]).minute(data.timeDurationForScribe.split(':')[1]).second(0).millisecond(0),
                                            startExamBetweenSpecifiedTime: data.startExamBetweenSpecifiedTime,
                                            examTimes: [],
                                            unlockWithPassword: data.unlockWithPassword ? 'Yes' : 'No',
                                            autoLogout: data.autoLogout ? 'Yes' : 'No',
                                            submitButtonDisplayMinutes: data.autoLogout ? dayjs.utc().hour(0).minute(0).second(0).millisecond(0) : dayjs.utc().hour(Math.floor(data.submitButtonDisplayMinutes / 60)).minute(data.submitButtonDisplayMinutes % 60).second(0).millisecond(0),
                                            calculator: data.calculator === 'none' ? 'No' : 'Yes',
                                            calculatorType: data.calculator === 'scientific' ? 'scientific' : 'normal',
                                            provideGraph: data.provideGraph ? 'Yes' : 'No',
                                            logarithm: data.logarithm ? 'Yes' : 'No',
                                            feedback: data.feedback ? 'Yes' : 'No',
                                            numberOfFeedbackQuestions: data.numberOfFeedbackQuestions ? data.numberOfFeedbackQuestions : 1,
                                            sectionWise: data.sectionWise ? 'Yes' : 'No',
                                            languages: data.languages,
                                            contentUploadMethod: data.contentUploadMethod,
                                            numberOfEasyQuestions: data.contentUploadMethod === 'bulk' ? data.numberOfEasyQuestions : 0,
                                            numberOfMediumQuestions: data.contentUploadMethod === 'bulk' ? data.numberOfMediumQuestions : 0,
                                            numberOfHardQuestions: data.contentUploadMethod === 'bulk' ? data.numberOfHardQuestions : 0,
                                            numberOfSets: data.numberOfSets,
                                            questionsPerSet: data.questionsPerSet,
                                            maxMarks: data.examType === 'MCQ' ? data.maxMarks : 1,
                                            randomizeQuestions: data.examType === 'MCQ' && data.randomizeQuestions ? 'Yes' : 'No',
                                            randomizeOptions: data.examType === 'MCQ' && data.randomizeOptions ? 'Yes' : 'No',
                                            isBilingual: data.isBilingual ? 'Yes' : 'No',
                                            instructionSheets: data.instructionSheets ? 'Yes' : 'No',
                                            biometricRequired: data.biometricRequired ? 'Yes' : 'No',
                                            biometricMethod: data.biometricMethod ? data.biometricMethod : 'photo',
                                            sampleTestRequired: data.sampleTestRequired ? 'Yes' : 'No',
                                            allQuestionsMandatory: data.allQuestionsMandatory ? 'Yes' : 'No',
                                            questionNavigationForwardOnly: data.questionNavigationForwardOnly ? 'Yes' : 'No',
                                            negativeMarking: data.negativeMarking ? 'Yes' : 'No',
                                            numberOfAnswerPages: data.examType === 'DESCRIPTIVE' ? data.numberOfAnswerPages : 1,
                                            maximumLoginAttempts: !isNaN(parseInt(data.maximumLoginAttempts)) ? 'Yes' : 'No',
                                            maximumLoginAttemptsCount: !isNaN(parseInt(data.maximumLoginAttempts)) ? parseInt(data.maximumLoginAttempts) : 1,
                                            loginBeforeMinutes: dayjs().utc().hour(data.loginBeforeMinutes.split(':')[0]).minute(data.loginBeforeMinutes.split(':')[1]).second(0).millisecond(0),
                                            reminders: data.reminders.map((reminder) => {
                                                return dayjs().utc().hour(reminder.split(':')[0]).minute(reminder.split(':')[1]).second(0).millisecond(0);
                                            }),
                                            lateLoginAllowed: data.lateLoginAllowed ? 'Yes' : 'No',
                                            lateLoginMinutes: dayjs().utc().hour(Math.floor(data.lateLoginMinutes / 60)).minute(data.lateLoginMinutes % 60).second(0).millisecond(0),
                                            instantScore: data.instantScore ? 'Yes' : 'No',
                                            instantResult: data.instantResult ? 'Yes' : 'No',
                                        }

                                        for (let batch of batches) {
                                            const existingBatch = data.examTimes.findIndex((examTime) => examTime.projectMasterId === batch.projectMasterId);
                                            let examTime = {
                                                projectMasterId: batch.projectMasterId,
                                                batchId: batch.batchId,
                                                batchName: batch.batchName,
                                            }
                                            if (existingBatch > -1) {
                                                examTime.examDate = dayjs.utc(data.examTimes[existingBatch].startTime);
                                                examTime.startTime = dayjs.utc(data.examTimes[existingBatch].startTime);
                                                examTime.endDate = dayjs.utc(data.examTimes[existingBatch].endTime);
                                                examTime.endTime = dayjs.utc(data.examTimes[existingBatch].endTime);
                                            } else {
                                                examTime.examDate = batch.examDate;
                                                examTime.startTime = batch.startTime;
                                                examTime.endDate = batch.endDate;
                                                examTime.endTime = batch.endTime;
                                            }
                                            dataToSet.examTimes.push(examTime);
                                        }

                                        if (data.sectionWise) {
                                            dataToSet.sectionCount = data.sectionCount;
                                            dataToSet.sectionNavigation = data.sectionNavigation;
                                            dataToSet.sections = data.sections.map((section) => {
                                                return {
                                                    ...section,
                                                    subSectionsCount: section.subSections.length,
                                                    sectionTime: dayjs.utc().hour(section.sectionTime.split(':')[0]).minute(section.sectionTime.split(':')[1]).second(0).millisecond(0),
                                                }
                                            });
                                        }
                                        setConfiguration({
                                            ...configuration,
                                            ...dataToSet
                                        });
                                    }
                                } catch (error) {
                                    console.log('There is an error while fetching content configuration details', error);
                                }
                            }
                            fetchDetails();
                        } else {
                            setConfiguration({
                                ...configuration,
                                examTimes: batches,
                            });
                        }
                    }
                } catch (error) {
                    console.log('There is an error while getting batches', error);
                }
            }
            getBatches();
        }
    }, [location, projectName, navigate]);





    return <MainContainer>
        <Menu>
            <Breadcrumbs aria-label="breadcrumb" separator='' sx={{ gap: 12 }}>
                <Typography sx={{ fontWeight: 400, textTransform: 'capitalize' }}>{projectDetails?.projectName}</Typography>
                <Box sx={{ display: 'flex', alignContent: 'center' }}>
                    <img src={ARROW} alt=''></img>
                </Box>

                <Typography color="text.primary" sx={{ fontWeight: 500 }}>Configuration Details</Typography>
                <Box sx={{ display: 'flex', alignContent: 'center' }}>
                    <img src={ARROW_OPEN} alt='' ></img>
                </Box>
            </Breadcrumbs>
        </Menu>
        <Container>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                maxHeight: 'calc(100vh - 116px)'
            }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    columnGap: 2,
                    rowGap: 0.5,
                    mb: 3
                }}>
                    <TextField
                        label="Drive Name"
                        variant="outlined"
                        value={drive['name']}
                        disabled
                        InputLabelProps={{
                            shrink: true,
                        }}
                        sx={{
                            width: 238,
                            bgcolor: 'background.base'
                        }}
                    />
                    <TextField
                        label="Course Name"
                        variant="outlined"
                        value={course['name']}
                        disabled
                        InputLabelProps={{
                            shrink: true
                        }}
                        sx={{
                            width: 238,
                            bgcolor: 'background.base'
                        }}
                    />
                    <Box sx={{ ml: 'auto' }}>


                        {<RadiusButton sx={{
                            borderRadius: 40,
                            textTransform: 'capitalize'
                        }} color="grey"
                            variant='contained'
                            size='large'
                            onClick={onGoBack}
                            startIcon={<img src={ARROW_LEFT} alt='' />}
                        >Go back</RadiusButton>}
                    </Box>
                </Box>
            </Box>

            <TableContainer sx={{
                // overflow: 'auto',
                border: '1px solid #E0E0E0',
                borderRadius: 1
            }}>
                <Table stickyHeader aria-label="table">
                    <TableBody>
                        <TableRow>
                            <TableCell>
                                <Typography component='span' variant='subtitle1'>
                                    Exam Type
                                    <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel id="examTypeLabel">Exam Type</InputLabel>
                                    <Select
                                        id="examType"
                                        labelId="examTypeLabel"
                                        label='Exam Type'
                                        sx={{
                                            width: '100%',
                                            maxWidth: 320,
                                            textTransform: 'capitalize',
                                        }}
                                        disabled
                                        value={configuration.examType}
                                        input={
                                            <OutlinedInput label='Exam Type' />
                                        }
                                    >
                                        <MenuItem value='MCQ'>MCQ</MenuItem>
                                        <MenuItem value='DESCRIPTIVE'>Paperless</MenuItem>
                                        <MenuItem value='TYPING'>Typing</MenuItem>
                                    </Select>
                                </FormControl>
                            </TableCell>
                            <TableCell sx={{ textAlign: 'right', color: 'primary.main' }}>
                                <Typography component='span' variant='subtitle1'>
                                    {configuration.examType === 'MCQ' ? 'MCQ' : configuration.examType === 'DESCRIPTIVE' ? 'Paperless' : 'Typing'}
                                </Typography>
                            </TableCell>
                        </TableRow>


                        {configuration.examTimes.map((examTime, index) => {
                            return <TableRow key={index}>
                                <TableCell sx={{ pt: index ? 0 : '', border: (index === configuration.examTimes.length - 1) ? '' : 'none', verticalAlign: 'top' }}>
                                    {index === 0 && <Typography component='span' variant='subtitle1'>
                                        Exam Times
                                        <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                    </Typography>}
                                </TableCell>
                                <TableCell sx={{ pt: index ? 0 : '', border: (index === configuration.examTimes.length - 1) ? '' : 'none' }}>
                                    <Typography component='div' sx={{ mb: 1 }} variant='subtitle1'>
                                        {`${examTime.batchName}`}
                                    </Typography>
                                    <Box>
                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                            <DatePicker
                                                size='small'
                                                label='Start Date'
                                                InputLabelProps={{
                                                    shrink: 'true'
                                                }}
                                                disabled
                                                format='DD-MM-YYYY'
                                                value={examTime.examDate}
                                                sx={{
                                                    flexGrow: 1,
                                                    maxWidth: 220,
                                                    '& .MuiInputBase-input': {
                                                        padding: '9px 14px !important',
                                                    },
                                                    '& .MuiFormLabel-root.Mui-error': {
                                                        color: 'rgba(0, 0, 0, 0.6)'
                                                    },
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'rgba(0, 0, 0, 0.23) !important'
                                                    }
                                                }} />
                                            <TimeField
                                                size='small'
                                                sx={{ width: 80 }}
                                                value={examTime.startTime}
                                                disabled
                                                label='Time'
                                                format="HH:mm"
                                            />
                                        </Box>
                                    </Box>
                                    {configuration.startExamBetweenSpecifiedTime && <Box sx={{ mt: 2 }}>
                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                            <DatePicker
                                                size='small'
                                                label='End Date'
                                                InputLabelProps={{
                                                    shrink: 'true'
                                                }}
                                                format='DD-MM-YYYY'
                                                value={examTime.endDate}
                                                minDate={examTime.startTime}
                                                disabled
                                                sx={{
                                                    flexGrow: 1,
                                                    maxWidth: 220,
                                                    '& .MuiInputBase-input': {
                                                        padding: '9px 14px !important',
                                                    },
                                                    '& .MuiFormLabel-root.Mui-error': {
                                                        color: 'rgba(0, 0, 0, 0.6)'
                                                    },
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'rgba(0, 0, 0, 0.23) !important'
                                                    }
                                                }} />
                                            <TimeField
                                                size='small'
                                                sx={{ width: 80 }}
                                                value={examTime.endTime}
                                                disabled
                                                label='Time'
                                                format="HH:mm"
                                            />
                                        </Box>
                                    </Box>}

                                </TableCell>
                                <TableCell sx={{ maxWidth: 195, pt: index ? 0 : '', border: (index === configuration.examTimes.length - 1) ? '' : 'none', textAlign: 'right', color: 'primary.main' }}>
                                    <Typography component='span' variant='subtitle1'>
                                        {examTime.startTime.format('HH') === '00' && examTime.startTime.format('mm') === '00'
                                            ? null
                                            : <span>
                                                {`Exam Start time is ${examTime.startTime.format('hh:mm a')} and `}
                                                {`Exam End time is ${dayjs(examTime.startTime).add(configuration.timeDuration.format('H'), 'hour').add(configuration.timeDuration.format('mm'), 'minute').format('hh:mm a')} and `}
                                                {` for scribe Exam End time is ${dayjs(examTime.startTime).add(configuration.timeDurationForScribe.format('H'), 'hour').add(configuration.timeDurationForScribe.format('mm'), 'minute').format('hh:mm a')} `}
                                            </span>}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        })}


                        {configuration.examType === 'MCQ'
                            ? <>
                                <TableRow>
                                    <TableCell sx={{
                                        borderColor: configuration.sectionWise === 'Yes' ? 'transparent !important' : ''
                                    }}>
                                        <Typography component='span' variant='subtitle1'>
                                            Section wise
                                            <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{
                                        borderColor:
                                            configuration.sectionWise === 'Yes' ? 'transparent !important' : ''
                                    }}>
                                        <RadioGroup row name="password-key-for-unlock">
                                            <FormControlLabel sx={{ width: 165 }} value='Yes' control={
                                                <Radio
                                                    disabled
                                                    checked={configuration.sectionWise === 'Yes'}
                                                />
                                            } label="Yes" />
                                            <FormControlLabel sx={{ width: 165 }} value='No' control={
                                                <Radio
                                                    disabled
                                                    checked={configuration.sectionWise === 'No'}
                                                />
                                            } label="No" />
                                        </RadioGroup>
                                    </TableCell>
                                    <TableCell sx={{
                                        textAlign: 'right',
                                        color: 'primary.main',
                                        borderColor: configuration.sectionWise === 'Yes' ? 'transparent !important' : ''
                                    }}>
                                        <Typography component='span' variant='subtitle1'>
                                            {configuration.sectionWise}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                {configuration.sectionWise === 'Yes' && <TableRow>
                                    <TableCell sx={{ border: 'none' }}>
                                        <Typography component='span' variant='subtitle1'>
                                            Section Navigation
                                            <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ border: 'none' }}>
                                        <FormControl sx={{ width: '100%' }}>
                                            <InputLabel id="sectionNavigationLabel">Section Navigation</InputLabel>
                                            <Select
                                                id="examType"
                                                labelId="sectionNavigationLabel"
                                                label='Section Navigation'
                                                sx={{
                                                    width: '100%',
                                                    maxWidth: 320,
                                                    textTransform: 'capitalize',
                                                }}
                                                disabled={true}
                                                value={configuration.sectionNavigation}
                                                input={
                                                    <OutlinedInput label='Section Navigation' />
                                                }
                                            >
                                                <MenuItem value='NO_MOVEMENT_OR_TIME_RESTRICTION'>No Movement Or Time Restriction</MenuItem>
                                                <MenuItem value='FIXED_TIME_AND_MOVEMENT_RESTRICTION'>Fixed Time And Movement Restriction</MenuItem>
                                                <MenuItem value='MOVEMENT_RESTRICTION_WITH_INCREMENTAL_TIME'>Movement Restriction With Incremental Time</MenuItem>
                                                <MenuItem value='MOVEMENT_RESTRICTION_WITH_NO_TIME'>Movement Restriction With No Time</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={{ textAlign: 'right', color: 'primary.main', border: 'none' }}>
                                        <Typography component='span' variant='subtitle1'>
                                            {
                                                configuration.sectionNavigation === 'NO_MOVEMENT_OR_TIME_RESTRICTION'
                                                    ? 'No Movement Or Time Restriction'
                                                    : configuration.sectionNavigation === 'FIXED_TIME_AND_MOVEMENT_RESTRICTION'
                                                        ? 'Fixed Time And Movement Restriction'
                                                        : configuration.sectionNavigation === 'MOVEMENT_RESTRICTION_WITH_INCREMENTAL_TIME'
                                                            ? 'Movement Restriction With Incremental Time'
                                                            : 'Movement Restriction With No Time'
                                            }
                                        </Typography>
                                    </TableCell>
                                </TableRow>}
                                {configuration.sectionWise === 'Yes' && (
                                    <TableRow>
                                        <TableCell sx={{ border: 'none' }}>
                                            <Typography component='span' variant='subtitle1'>
                                                How many sections
                                                <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ border: 'none' }}>
                                            <Paper
                                                component="form" autoComplete='off'
                                                sx={{
                                                    display: 'flex', alignItems: 'center', width: 180, borderRadius: 2, boxShadow: 'none', border: '1px solid #A3A3A3!important'
                                                }}
                                            >
                                                <InputBase
                                                    sx={{ ml: 1, flex: 1 }}
                                                    placeholder="Enter Count"
                                                    type='number'
                                                    value={configuration.sectionCount}
                                                    disabled
                                                />
                                            </Paper>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'right', color: 'primary.main', border: 'none' }}>
                                            <Typography component='span' variant='subtitle1'>
                                                {configuration.sectionWise}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                                {configuration.sectionWise === 'Yes' && (
                                    configuration.sections.map((section, index) => <TableRow key={index}>
                                        <TableCell sx={{
                                            pt: 0,
                                            borderColor: index === configuration.sections.length - 1 ? '' : 'transparent !important',
                                            verticalAlign: 'top !important'
                                        }}>
                                            <Typography component='span' variant='subtitle1'>
                                                {`Section ${index + 1}`}
                                                <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{
                                            pt: 0,
                                            borderColor: index === configuration.sections.length - 1 ? '' : 'transparent !important'
                                        }}>
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'flex-start',
                                                gap: 1,
                                            }}>
                                                <TextField
                                                    sx={{ width: 220 }}
                                                    size='small'
                                                    id="section-title"
                                                    label="Section Title"
                                                    variant="outlined"
                                                    value={configuration.sections[index].sectionTitle}
                                                    disabled
                                                />
                                                {(configuration.sectionNavigation === 'FIXED_TIME_AND_MOVEMENT_RESTRICTION' || configuration.sectionNavigation === 'MOVEMENT_RESTRICTION_WITH_INCREMENTAL_TIME') && <TimeField
                                                    size='small'
                                                    sx={{ width: 80 }}
                                                    defaultValue={configuration.sections[index].sectionTime}
                                                    value={configuration.sections[index].sectionTime}
                                                    format="HH:mm"
                                                    disabled
                                                />}

                                            </Box>

                                            <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2 }}>

                                                <InputLabel sx={{ mt: 1, fontSize: 13 }}>How many sub sections</InputLabel>
                                                <Paper
                                                    component="form" autoComplete='off'
                                                    sx={{
                                                        my: 1,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        width: 180,
                                                        height: 32,
                                                        borderRadius: 2,
                                                        boxShadow: 'none',
                                                        border: '1px solid #A3A3A3!important'
                                                    }}
                                                >
                                                    <InputBase
                                                        sx={{ ml: 1, flex: 1, p: 0 }}
                                                        placeholder="Enter Count"
                                                        type='number'
                                                        value={section.subSectionsCount}
                                                        disabled
                                                    />
                                                </Paper>
                                                {section.subSections.map((subSection, subIndex) => <Box key={subIndex}>
                                                    <TextField
                                                        sx={{ width: 220, mt: 1.5 }}
                                                        size='small'
                                                        id="section-title"
                                                        label={`Sub Section ${subIndex + 1}`}
                                                        variant="outlined"
                                                        value={subSection}
                                                        disabled
                                                        InputLabelProps={{
                                                            shrink: true
                                                        }}
                                                    />
                                                </Box>)}
                                            </Box>
                                        </TableCell>
                                        <TableCell sx={{
                                            textAlign: 'right',
                                            color: 'primary.main',
                                            pt: 0,
                                            borderColor: index === configuration.sections.length - 1 ? '' : 'transparent !important',
                                            verticalAlign: 'top !important'
                                        }}>
                                            <Typography component='span' variant='subtitle1'>
                                                {`${configuration.sections?.[index]?.sectionTime?.format('HH')} Hours ${configuration.sections?.[index]?.sectionTime?.format('mm')} Minutes`}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>)
                                )}
                                <TableRow>
                                    <TableCell>
                                        <Typography component='span' variant='subtitle1'>
                                            Questions Per Set
                                            <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <InputBase
                                            sx={{
                                                py: 0.7,
                                                px: 1,
                                                width: 180,
                                                borderRadius: 2,
                                                border: '1px solid'
                                            }}
                                            placeholder="Enter Count"
                                            type='number'
                                            value={configuration.questionsPerSet}
                                            disabled
                                        />
                                    </TableCell>
                                    <TableCell sx={{
                                        textAlign: 'right',
                                        color: 'primary.main'
                                    }}>
                                        <Typography component='span' variant='subtitle1'>
                                            {configuration.questionsPerSet} Questions
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ borderColor: configuration.contentUploadMethod === 'bulk' ? 'transparent !important' : null }}>
                                        <Typography component='span' variant='subtitle1'>
                                            Content Upload Method
                                            <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ borderColor: configuration.contentUploadMethod === 'bulk' ? 'transparent !important' : null }}>
                                        <RadioGroup row name="instructionSheet">
                                            <FormControlLabel sx={{ width: 165 }} value='set' control={
                                                <Radio
                                                    disabled
                                                    checked={configuration.contentUploadMethod === 'set'}
                                                />
                                            } label="Multiple sets" />
                                            <FormControlLabel sx={{ width: 165 }} value='bulk' control={
                                                <Radio
                                                    disabled
                                                    checked={configuration.contentUploadMethod === 'bulk'}
                                                />
                                            } label="Bulk upload" />
                                        </RadioGroup>
                                    </TableCell>
                                    <TableCell sx={{
                                        textAlign: 'right',
                                        color: 'primary.main',
                                        borderColor: configuration.contentUploadMethod === 'bulk' ? 'transparent !important' : null
                                    }}>
                                        <Typography component='span' variant='subtitle1'>
                                            {configuration.contentUploadMethod === 'set' ? 'Multiple sets' : 'Bulk upload'}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                {configuration.contentUploadMethod === 'bulk' && <>
                                    <TableRow>
                                        <TableCell sx={{ borderColor: 'transparent !important' }}>
                                            <Typography component='span' variant='subtitle1'>
                                                Number of easy questions
                                                <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ borderColor: 'transparent !important' }}>
                                            <InputBase
                                                sx={{
                                                    py: 0.7,
                                                    px: 1,
                                                    width: 180,
                                                    borderRadius: 2,
                                                    border: '1px solid #A3A3A3!important'
                                                }}
                                                placeholder="Enter Count"
                                                type='number'
                                                disabled
                                                value={configuration.numberOfEasyQuestions}
                                            />
                                        </TableCell>
                                        <TableCell sx={{
                                            borderColor: 'transparent !important'
                                        }}></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ borderColor: 'transparent !important' }}>
                                            <Typography component='span' variant='subtitle1'>
                                                Number of medium questions
                                                <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ borderColor: 'transparent !important' }}>
                                            <InputBase
                                                sx={{
                                                    py: 0.7,
                                                    px: 1,
                                                    width: 180,
                                                    borderRadius: 2,
                                                    border: '1px solid #A3A3A3!important'
                                                }}
                                                placeholder="Enter Count"
                                                type='number'
                                                disabled
                                                value={configuration.numberOfMediumQuestions}
                                            />
                                        </TableCell>
                                        <TableCell sx={{
                                            borderColor: 'transparent !important'
                                        }}></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <Typography component='span' variant='subtitle1'>
                                                Number of hard questions
                                                <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <InputBase
                                                sx={{
                                                    py: 0.7,
                                                    px: 1,
                                                    width: 180,
                                                    borderRadius: 2,
                                                    border: '1px solid #A3A3A3!important'
                                                }}
                                                placeholder="Enter Count"
                                                type='number'
                                                disabled
                                                value={configuration.numberOfHardQuestions}
                                            />
                                        </TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </>
                                }
                            </>
                            : null
                        }
                        <TableRow>
                            <TableCell>
                                <Typography component='span' variant='subtitle1'>
                                    Number of Sets
                                    <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <InputBase
                                    sx={{
                                        py: 0.7,
                                        px: 1,
                                        width: 180,
                                        borderRadius: 2,
                                        border: '1px solid #A3A3A3!important'
                                    }}
                                    placeholder="Enter Count"
                                    type='number'
                                    disabled
                                    value={configuration.numberOfSets}
                                />
                            </TableCell>
                            <TableCell sx={{
                                textAlign: 'right',
                                color: 'primary.main'
                            }}>
                                <Typography component='span' variant='subtitle1'>
                                    {configuration.numberOfSets} Sets
                                </Typography>
                            </TableCell>
                        </TableRow>

                        {configuration.examType === 'MCQ' && (
                            <Fragment>
                                <TableRow>
                                    <TableCell>
                                        <Typography component='span' variant='subtitle1'>
                                            Max Marks
                                            <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <InputBase
                                            sx={{
                                                py: 0.7,
                                                px: 1,
                                                width: 180,
                                                borderRadius: 2,
                                                border: '1px solid'
                                            }}
                                            placeholder="Enter Count"
                                            type='number'
                                            value={configuration.maxMarks}
                                            disabled
                                        />
                                    </TableCell>
                                    <TableCell sx={{
                                        textAlign: 'right',
                                        color: 'primary.main'
                                    }}>
                                        <Typography component='span' variant='subtitle1'>
                                            {configuration.maxMarks} Marks
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography component='span' variant='subtitle1'>
                                            Randomize Questions
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <RadioGroup row name="exam-type">
                                            <FormControlLabel sx={{ width: 165 }} value='Yes' control={
                                                <Radio
                                                    disabled
                                                    checked={configuration.randomizeQuestions === 'Yes'}
                                                />
                                            } label="Yes" />
                                            <FormControlLabel sx={{ width: 165 }} value='No' control={
                                                <Radio
                                                    disabled
                                                    checked={configuration.randomizeQuestions === 'No'}
                                                />
                                            } label="No" />
                                        </RadioGroup>
                                    </TableCell>
                                    <TableCell sx={{
                                        textAlign: 'right',
                                        color: 'primary.main'
                                    }}>
                                        <Typography component='span' variant='subtitle1'>
                                            {configuration.randomizeQuestions}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography component='span' variant='subtitle1'>
                                            Randomize Options
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <RadioGroup row name="exam-type">
                                            <FormControlLabel sx={{ width: 165 }} value='Yes' control={
                                                <Radio
                                                    disabled
                                                    checked={configuration.randomizeOptions === 'Yes'}
                                                />
                                            } label="Yes" />
                                            <FormControlLabel sx={{ width: 165 }} value='No' control={
                                                <Radio
                                                    disabled
                                                    checked={configuration.randomizeOptions === 'No'}
                                                />
                                            } label="No" />
                                        </RadioGroup>
                                    </TableCell>
                                    <TableCell sx={{
                                        textAlign: 'right',
                                        color: 'primary.main'
                                    }}>
                                        <Typography component='span' variant='subtitle1'>
                                            {configuration.randomizeOptions}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </Fragment>
                        )}

                        <TableRow>
                            <TableCell sx={{ border: 'none' }}>
                                <Typography component='span' variant='subtitle1'>
                                    Multilingual content
                                    <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                </Typography>
                            </TableCell>
                            <TableCell sx={{ border: 'none' }}>
                                <RadioGroup row name="isBilingual" >
                                    <FormControlLabel sx={{ width: 165 }} value='Yes' control={
                                        <Radio
                                            disabled
                                            checked={configuration.isBilingual === 'Yes'}
                                        />
                                    } label="Yes" />
                                    <FormControlLabel sx={{ width: 165 }} value='No' control={
                                        <Radio
                                            disabled
                                            checked={configuration.isBilingual === 'No'}
                                        />
                                    } label="No" />
                                </RadioGroup>
                            </TableCell>
                            <TableCell sx={{ textAlign: 'right', color: 'primary.main', border: 'none' }}>
                                <Typography component='span' variant='subtitle1'>
                                    {configuration.isBilingual}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{ pt: 0 }}>
                                <Typography component='span' variant='subtitle1'>
                                    How many languages
                                    <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                </Typography>
                            </TableCell>
                            <TableCell sx={{ pt: 0 }}>
                                {configuration.isBilingual === 'No' && (
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel id="bilingualLabel">Languages</InputLabel>
                                        <Select
                                            labelId="bilingualLabel"
                                            id="bilingualSingleSelect"
                                            sx={{
                                                width: '100%',
                                                maxWidth: 320,
                                                textTransform: 'capitalize',
                                            }}
                                            disabled
                                            value={configuration.languages[0] ?? ''}
                                            input={
                                                <OutlinedInput label='Languages' />
                                            }
                                        >
                                            <MenuItem value=''>None</MenuItem>
                                            {languages.map((language) => {
                                                return <MenuItem sx={{
                                                    textTransform: 'capitalize'
                                                }}
                                                    key={language}
                                                    value={language}
                                                >
                                                    {language}
                                                </MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                )}
                                {configuration.isBilingual === 'Yes' && (
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel id="bilingualMultiLabel">Languages</InputLabel>
                                        <Select
                                            labelId="bilingualMultiLabel"
                                            id="bilingualMultiSelect"
                                            multiple
                                            sx={{
                                                width: '100%',
                                                maxWidth: 320
                                            }}
                                            disabled
                                            value={configuration.languages}
                                            input={
                                                <OutlinedInput id="select-multiple-chip" label='Languages' />
                                            }
                                            renderValue={(selected) => <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                                                {selected.map((value) => (
                                                    <Box key={value} sx={{
                                                        display: 'flex',
                                                        gap: 1.5,
                                                        bgcolor: 'primary.50',
                                                        py: 0.5,
                                                        px: 1.5,
                                                        borderRadius: 1,
                                                        textTransform: 'capitalize',
                                                    }}>
                                                        <span>{value}</span>
                                                    </Box>
                                                ))}
                                            </Box>
                                            }
                                        >
                                            {languages.map((language) => (
                                                <MenuItem sx={{
                                                    textTransform: 'capitalize'
                                                }}
                                                    key={language}
                                                    value={language}
                                                >
                                                    {language}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}

                            </TableCell>
                            <TableCell sx={{ textAlign: 'right', color: 'primary.main', pt: 0 }}>
                                <Typography component='span' variant='subtitle1' sx={{ textTransform: 'capitalize' }}>
                                    {configuration.languages.join(', ')}
                                </Typography>
                            </TableCell>
                        </TableRow>

                        {configuration.examType === 'MCQ' && (
                            <TableRow>
                                <TableCell>
                                    <Typography component='span' variant='subtitle1'>
                                        All Questions Mandatory
                                        <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <RadioGroup row name="instructionSheet">
                                        <FormControlLabel sx={{ width: 165 }} value='Yes' control={
                                            <Radio
                                                disabled
                                                checked={configuration.allQuestionsMandatory === 'Yes'}
                                            />
                                        } label="Yes" />
                                        <FormControlLabel sx={{ width: 165 }} value='No' control={
                                            <Radio
                                                disabled
                                                checked={configuration.allQuestionsMandatory === 'No'}
                                            />
                                        } label="No" />
                                    </RadioGroup>
                                </TableCell>
                                <TableCell sx={{
                                    textAlign: 'right',
                                    color: 'primary.main',
                                }}>
                                    <Typography component='span' variant='subtitle1'>
                                        {configuration.allQuestionsMandatory}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}

                        {configuration.examType === 'MCQ' && (
                            <TableRow>
                                <TableCell>
                                    <Typography component='span' variant='subtitle1'>
                                        Questions Navigation Forward Only
                                        <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <RadioGroup row name="instructionSheet">
                                        <FormControlLabel sx={{ width: 165 }} value='Yes' control={
                                            <Radio
                                                disabled
                                                checked={configuration.questionNavigationForwardOnly === 'Yes'}
                                            />
                                        } label="Yes" />
                                        <FormControlLabel sx={{ width: 165 }} value='No' control={
                                            <Radio
                                                disabled
                                                checked={configuration.questionNavigationForwardOnly === 'No'}
                                            />
                                        } label="No" />
                                    </RadioGroup>
                                </TableCell>
                                <TableCell sx={{
                                    textAlign: 'right',
                                    color: 'primary.main',
                                }}>
                                    <Typography component='span' variant='subtitle1'>
                                        {configuration.questionNavigationForwardOnly}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {configuration.examType === 'MCQ' && (
                            <TableRow>
                                <TableCell>
                                    <Typography component='span' variant='subtitle1'>
                                        Negative Marking
                                        <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <RadioGroup row name="instructionSheet">
                                        <FormControlLabel sx={{ width: 165 }} value='Yes' control={
                                            <Radio
                                                disabled
                                                checked={configuration.negativeMarking === 'Yes'}
                                            />
                                        } label="Yes" />
                                        <FormControlLabel sx={{ width: 165 }} value='No' control={
                                            <Radio
                                                disabled
                                                checked={configuration.negativeMarking === 'No'}
                                            />
                                        } label="No" />
                                    </RadioGroup>
                                </TableCell>
                                <TableCell sx={{
                                    textAlign: 'right',
                                    color: 'primary.main',
                                }}>
                                    <Typography component='span' variant='subtitle1'>
                                        {configuration.negativeMarking}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}

                        {configuration.examType === 'DESCRIPTIVE'
                            ? <TableRow>
                                <TableCell>
                                    <Typography component='span' variant='subtitle1'>
                                        Number of Answer Pages
                                        <Box component='span' sx={{ color: 'error.main', ml: 0.25 }}>*</Box>
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <InputBase
                                        sx={{
                                            py: 0.7,
                                            px: 1,
                                            width: 180,
                                            borderRadius: 2,
                                            border: '1px solid #A3A3A3!important'
                                        }}
                                        placeholder="Enter Count"
                                        type='number'
                                        disabled
                                        value={configuration.numberOfAnswerPages}
                                    />
                                </TableCell>
                                <TableCell sx={{
                                    textAlign: 'right',
                                    color: 'primary.main'
                                }}>
                                    <Typography component='span' variant='subtitle1'>
                                        {configuration.numberOfAnswerPages} Pages
                                    </Typography>
                                </TableCell>
                            </TableRow>
                            : null}

                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    </MainContainer>
}